import Vue from 'vue';
import Router from 'vue-router';

// views
import Home from '@/views/Home.vue';
import Verification from '@/views/Verification.vue';
import DocutaxSubmission from '@/views/DocutaxSubmission.vue';
import DocutaxRequestReply from '@/views/DocutaxRequestReply.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    component: Home,
    name: 'home',
  },
  {
    path: '/:clientId/verification/',
    component: Verification,
    name: 'verification',
    props: route => ({ clientId: parseInt(route.params.clientId, 10) }),
  },
  {
    path: '/:clientId/send-docutax-request/',
    component: DocutaxSubmission,
    name: 'docutaxSubmission',
    props: route => ({ clientId: parseInt(route.params.clientId, 10) }),
  },
  {
    path: '/r/:requestUrlSlug',
    component: DocutaxRequestReply,
    name: 'docutaxRequestReply',
    props: route => ({ requestUrlSlug: route.params.requestUrlSlug }),
  },
];

const router = new Router({
  routes,
});

// Google Analytics 
router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', 'G-SF5PB16B8B', {
      page_path: to.fullPath
    })
  }
});

export default router;
